import { Check } from 'lucide-react';
import { cn } from '@/utils/helpers/classnames';

interface CheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  ariaLabel?: string;
  className?: string;
  boxClassName?: string;
  checkIconClassName?: string;
  showCheckmark?: boolean;
}

export function Checkbox({
  checked,
  onChange,
  disabled = false,
  ariaLabel,
  className = '',
  boxClassName = '',
  checkIconClassName = '',
  showCheckmark = true,
}: CheckboxProps) {
  return (
    <label
      className={cn(
        'relative inline-flex cursor-pointer items-center justify-center rounded-md',
        disabled ? 'cursor-not-allowed opacity-60' : '',
        className
      )}
    >
      <input
        type="checkbox"
        className="sr-only peer"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        disabled={disabled}
        aria-label={ariaLabel}
      />

      <span
        className={cn(
          'flex h-6 w-6 items-center justify-center rounded-md border border-gray-300 bg-white/85 transition-colors peer-checked:border-[#0F8A47] peer-checked:bg-[#0F8A47] peer-focus-visible:ring-2 peer-focus-visible:ring-[#0F8A47]/30',
          boxClassName
        )}
      />

      {showCheckmark && (
        <Check
          className={cn(
            'pointer-events-none absolute h-4 w-4 text-transparent transition-colors peer-checked:text-white',
            checkIconClassName
          )}
        />
      )}
    </label>
  );
}

export default Checkbox;
